import { getErrorCode } from '../../../common/api/errors'

export const CURRENT_PASSWORD_INVALID = 'CURRENT_PASSWORD_INVALID'

const TEXT_BY_CODE: Record<string, string> = {
  CURRENT_PASSWORD_INVALID: 'Текущий пароль указан неверно.',
  SECOND_FACTOR_INVALID: 'Неверный код.',
  PASSKEY_LIMIT_REACHED: 'У учётной записи уже максимальное число ключей. Удалите ненужный.',
  SECOND_FACTOR_NOT_ENABLED: 'Сначала подключите приложение-аутентификатор.',
  SECOND_FACTOR_ALREADY_ENABLED: 'Приложение-аутентификатор уже подключено.',
  RATE_LIMIT_EXCEEDED: 'Слишком много попыток. Попробуйте позже.',
  VALIDATION_ERROR: 'Новый пароль должен быть от 6 до 255 символов.',
}

/** What to tell the person about a refused account request. */
export const accountErrorText = (error: unknown, fallback = 'Не удалось выполнить действие. Попробуйте ещё раз.'): string => {
  const code = getErrorCode(error)
  if (code && TEXT_BY_CODE[code]) {
    return TEXT_BY_CODE[code]
  }

  return (error as { status?: number } | undefined)?.status === 429 ? TEXT_BY_CODE.RATE_LIMIT_EXCEEDED : fallback
}

/** The payload of a successful answer; a refusal in a 200 envelope is thrown like any other. */
export const dataOf = <T,>(response: { data: { success: boolean; data?: T } }): T => {
  if (!response?.data?.success) {
    throw response
  }

  return response.data.data as T
}
